import { StringKeyDictionary } from "../commonInterfaces.js";
import { FullHeightContainer } from "../core/components/FullHeighContainer.js";
import { ResourceSearchSkills } from "../core/components/skills/resourceSearchSkills.js";
import { MatrixParams, SkillsMatrix } from "../core/components/skills/skillsMatrix.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService } from "../core/util/httpManager.js";
import React from "react";
export class RequirementProfile extends React.Component<{
    isWindow: boolean;
    triggerSearch: () => void;
    queryParameters: StringKeyDictionary<any>;
    children: React.ReactNode;
}, {
    filter: MatrixParams;
}> {
    private _skillsRef: ResourceSearchSkills = null;
    private _tabStripElementRef = null;
    private _matrixRef: SkillsMatrix = null;
    private filterActive: boolean = null;

    constructor(props) {
        super(props);
        this.state = {
            filter: {
                AssignmentGuids: this.props.queryParameters.eventIsGuids ? this.props.queryParameters.eventIsGuids.split(",") : null,
                Start: new Date(),
                End: Helper.dates.addDays(new Date(), 7),
                IsAvailibilityFilterActive: false,
                MatchAllRequirementsActive: false,
                RequiredSkills: []
            }
        }
    }

    componentDidMount() {
        $(this._tabStripElementRef).kendoTabStrip({
            animation: false
        }).data("kendoTabStrip");
    }

    public getSkillsJSON = () => {
        return this._skillsRef.getSkillsJSON();
    }

    public filterMatrix = (ressNrs: string[]) => {
        this._matrixRef.filterMatrix(ressNrs);
    }

    public getMatrix = async () => {
        var result = null;
        let params: MatrixParams = JSON.parse(JSON.stringify(this.state.filter));
        let useMatrix = params.IsAvailibilityFilterActive || (params.RequiredSkills && params.RequiredSkills.length > 0);
        if (useMatrix) {
            result = await HTTPService.post("Skills/GetMatrix", params);
        }
        this._matrixRef.updateMatrix(result, params);
        this.filterActive = useMatrix;
        return result;
    }

    private onFilterChanged = (filter: MatrixParams, triggerSearch: boolean) => {
        this.setState({ filter: filter }, () => {
            if (triggerSearch)
                this.props.triggerSearch();
        })
    }

    private getFilterActiveWarning = () => {
        let warning = null;
        if (this.filterActive)
            warning = <div style={{ margin: "5px", alignSelf: "center" }}><i className={"fal fa-exclamation-triangle"} color="red" title={Helper.getTranslation("Skills.FilterActive")} /></div>;
        return warning;
    }

    render() {
        return <FullHeightContainer>
            <div className="inno-tab-strip-wrapper flex-container__item flex-container" ref={(r) => this._tabStripElementRef = r}>
                <ul className="">
                    <li className="k-active">{Helper.getTranslation("Server.Allgemein")}</li>
                    <li>{Helper.getTranslation("Ressource.SkillMatrixProfile")}</li>
                    <li>
                        {Helper.getTranslation("Ressource.Anforderungsprofil")}
                        {this.getFilterActiveWarning()}
                    </li>
                </ul>
                <div className="flex-container__item flex-container" style={{ padding: "0" }}>
                    {this.props.children}
                </div>
                <div className="flex-container__item flex-container" style={{ padding: "0", overflow: "hidden" }}>
                    <SkillsMatrix isWindow={this.props.isWindow} ref={(ref) => this._matrixRef = ref} />
                </div>
                <div className="flex-container__item flex-container" style={{ overflow: "hidden" }}>
                    <ResourceSearchSkills
                        queryParameters={this.props.queryParameters}
                        ref={(r) => this._skillsRef = r}
                        isWindow={this.props.isWindow}
                        initialFilter={this.state.filter}
                        onFilterChanged={this.onFilterChanged} />
                </div>
            </div>
        </FullHeightContainer>
    }
}